import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "../styles/carta.css";

export const Efrst = () => {

 return (

    <main className="carta">

      <section className="carta-header">

        <div className="carta-header__wrap">

          <h1 className="carta-header__title">

           Experiencias Formativas en situaciones Reales de Trabajo

          </h1>

          <p className="carta-header__subtitle">
            Explora nuestro sistema y mejora tus procesos
          </p>
           
          <div className="carta-info">

            <div className="carta-info__img">
            <img   src="/img/estudiante2.png"  alt="Estudiante" />
          </div>

            <p className="carta-info__text">
              Nuestra plataforma permite gestionar de manera eficiente las
              Experiencias Formativas en Situaciones Reales de Trabajo (EFSRT)
              dentro del instituto. Administra estudiantes, docentes,
              empresas, seguimientos, evaluaciones y reportes en un solo
              sistema moderno, optimizando los procesos académicos y
              fortaleciendo la conexión entre la formación profesional y el
              entorno laboral real.
            </p>
            
              <Link to="https://www.lcc.pertisoft.com/"   className="btn-ver" target="_blank"> Ver Sistema </Link>
           
            
          </div>


        </div>

      </section>

 </main>

  );
};

